// Code generated by go generate; DO NOT EDIT.

export const supportedDatasources = new Set<string>([
  '__expr__',
  'aggregations-io-datasource',
  'apache-iotdb-datasource',
  'aquaqanalytics-kdbbackend-datasource',
  'axiomhq-axiom-datasource',
  'cloudwatch',
  'cnos-cnosdb-datasource',
  'datasource',
  'dlopes7-appdynamics-datasource',
  'dvelop-odata-datasource',
  'elasticsearch',
  'factry-historian-datasource',
  'fiskaly-surrealdb-datasource',
  'frser-sqlite-datasource',
  'grafadruid-druid-datasource',
  'grafana-athena-datasource',
  'grafana-azure-data-explorer-datasource',
  'grafana-azure-monitor-datasource',
  'grafana-azurecosmosdb-datasource',
  'grafana-bigquery-datasource',
  'grafana-catchpoint-datasource',
  'grafana-clickhouse-datasource',
  'grafana-databricks-datasource',
  'grafana-datadog-datasource',
  'grafana-dynamodb-datasource',
  'grafana-dynatrace-datasource',
  'grafana-falconlogscale-datasource',
  'grafana-github-datasource',
  'grafana-gitlab-datasource',
  'grafana-honeycomb-datasource',
  'grafana-iot-sitewise-datasource',
  'grafana-jira-datasource',
  'grafana-looker-datasource',
  'grafana-mock-datasource',
  'grafana-mongodb-datasource',
  'grafana-newrelic-datasource',
  'grafana-odbc-datasource',
  'grafana-opensearch-datasource',
  'grafana-oracle-datasource',
  'grafana-orbit-datasource',
  'grafana-pagerduty-datasource',
  'grafana-postgresql-datasource',
  'grafana-redshift-datasource',
  'grafana-salesforce-datasource',
  'grafana-saphana-datasource',
  'grafana-sentry-datasource',
  'grafana-servicenow-datasource',
  'grafana-snowflake-datasource',
  'grafana-splunk-datasource',
  'grafana-splunk-monitoring-datasource',
  'grafana-sumologic-datasource',
  'grafana-surrealdb-datasource',
  'grafana-testdata-datasource',
  'grafana-timestream-datasource',
  'grafana-wavefront-datasource',
  'grafana-x-ray-datasource',
  'graphite',
  'hadesarchitect-cassandra-datasource',
  'highlightinc-highlight-datasource',
  'ibm-aql-datasource',
  'ibm-kql-datasource',
  'influxdata-flightsql-datasource',
  'influxdb',
  'innius-grpc-datasource',
  'kniepdennis-neo4j-datasource',
  'loki',
  'manassehzhou-maxcompute-datasource',
  'marcusolsson-csv-datasource',
  'mssql',
  'mysql',
  'nagasudhirpulla-api-datasource',
  'needleinajaystack-haystack-datasource',
  'oci-metrics-datasource',
  'opentsdb',
  'parseable-parseable-datasource',
  'postgres',
  'prometheus',
  'questdb-questdb-datasource',
  'quickwit-quickwit-datasource',
  'redis-datasource',
  'retrodaredevil-wildgraphql-datasource',
  'stackdriver',
  'tdengine-datasource',
  'timeplus-proton-datasource',
  'trino-datasource',
  'vertamedia-clickhouse-datasource',
  'vertica-grafana-datasource',
  'ydbtech-ydb-datasource',
  'yesoreyeram-infinity-datasource',
]);
